// Funções
const funcoes = {
  VISITANTE: 'VISITANTE',
  COMPRADOR: 'COMPRADOR',
  VENDEDOR: 'VENDEDOR',
  PREGOEIRO: 'PREGOEIRO',
  PREGOEIRO_SUBSTITUTO: 'PREGOEIRO-SUBSTITUTO',
  'AGENTE-CONTRATACAO': 'AGENTE-CONTRATACAO',
  'AGENTE-CONTRATACAO-SUBSTITUTO': 'AGENTE-CONTRATACAO-SUBSTITUTO',
  AUTORIDADE: 'AUTORIDADE',
  FORNECEDOR: 'FORNECEDOR',
  LICITANTE: 'LICITANTE',
  USUARIO: 'USUARIO',
};

const SituacaoEnum = Object.freeze({
  CADASTRADA: 1,
  EDITAL_PUBLICADO: 2,
  ENTREGA_DE_PROPOSTAS: 3,
  AGUARDANDO_INICIO_SESSAO: 4,
  ANALISANDO_PROPOSTAS: 5,
  LANCES: 6,
  PREFERENCIA: 7,
  NEGOCIACAO: 8,
  HABILITACAO: 9,
  INTERPOSICAO_DE_RECURSOS: 10,
  ADESAO_DE_PRECO: 11,
  FRACASSADA: 12,
  DESERTA: 13,
  REVOGADA: 14,
  ENCERRADA_COM_VENCEDOR: 15,
  ENCERRADA_COM_RECURSO: 16,
  SUSPENSA: 17,
  ANULADA: 18,
  JULGAMENTO: 19,
  MANIFESTACAO_INTENCAO_RECURSO: 20,
});

const SituacaoLabel = Object.freeze({
  [SituacaoEnum.CADASTRADA]: 'Cadastrada',
  [SituacaoEnum.EDITAL_PUBLICADO]: 'Edital Publicado',
  [SituacaoEnum.ENTREGA_DE_PROPOSTAS]: 'Entrega de Propostas',
  [SituacaoEnum.AGUARDANDO_INICIO_SESSAO]: 'Aguardando Início de Sessão',
  [SituacaoEnum.ANALISANDO_PROPOSTAS]: 'Analisando Propostas',
  [SituacaoEnum.LANCES]: 'Lances',
  [SituacaoEnum.PREFERENCIA]: 'Preferência',
  [SituacaoEnum.NEGOCIACAO]: 'Negociação',
  [SituacaoEnum.HABILITACAO]: 'Habilitação',
  [SituacaoEnum.INTERPOSICAO_DE_RECURSOS]: 'Interposição de Recursos',
  [SituacaoEnum.ADESAO_DE_PRECO]: 'Adesão de Preço',
  [SituacaoEnum.FRACASSADA]: 'Fracassada',
  [SituacaoEnum.DESERTA]: 'Deserta',
  [SituacaoEnum.REVOGADA]: 'Revogada',
  [SituacaoEnum.ENCERRADA_COM_VENCEDOR]: 'Encerrada com Vencedor',
  [SituacaoEnum.ENCERRADA_COM_RECURSO]: 'Encerrada com Recurso',
  [SituacaoEnum.SUSPENSA]: 'Suspensa',
  [SituacaoEnum.ANULADA]: 'Anulada',
  [SituacaoEnum.JULGAMENTO]: 'Julgamento',
  [SituacaoEnum.MANIFESTACAO_INTENCAO_RECURSO]: 'Manifestação de Intenção de Recurso',
});

const getOfertaCompraEnum = tipo => {
  const normalized = (tipo || '').toString().toLowerCase();
  switch (normalized) {
    case 'concorrencia':
      return {
        type: 'CONCORRENCIA',
        titleSingular: 'Concorrência Eletrônica',
        titlePlural: 'Concorrências Eletrônicas',
        buttonTitle: 'Criar Concorrência',
        label: 'Concorrência',
      };
    case 'dispensa':
      return {
        type: 'DISPENSA',
        titleSingular: 'Dispensa Eletrônica',
        titlePlural: 'Dispensas Eletrônicas',
        buttonTitle: 'Criar Dispensa',
        label: 'Dispensa',
      };
    default:
      return {
        type: 'PREGAO',
        titleSingular: 'Pregão Eletrônico',
        titlePlural: 'Pregões Eletrônicos',
        buttonTitle: 'Criar Pregão',
        label: 'Pregão',
      };
  }
};

const verificarPregoeiro = funcao =>
  funcao === funcoes.PREGOEIRO || funcao === funcoes['AGENTE-CONTRATACAO'];
/** Status do vínculo empresa/plano de cobrança */
const BILLING_STATUS = Object.freeze({
  ATIVO: 'ATIVO',
  AGUARDANDO: 'AGUARDANDO',
  SUSPENSO: 'SUSPENSO',
  CONCLUIDO: 'CONCLUIDO',
});

const BILLING_TYPE = Object.freeze({
  MONTHLY: 'MONTHLY',
  AVULSA: 'AVULSA',
  PERCENTUAL: 'PERCENTUAL',
});

const verificarComprador = funcao => funcao === funcoes.COMPRADOR;
const verificarVendedor = funcao => funcao === funcoes.VENDEDOR;
const verificarFornecedor = funcao => funcao === funcoes.FORNECEDOR;
const verificarLicitante = funcao => funcao === funcoes.LICITANTE;
const verificarVisitante = funcao => funcao === funcoes.VISITANTE;

export {
  funcoes,
  SituacaoEnum,
  SituacaoLabel,
  BILLING_STATUS,
  BILLING_TYPE,
  getOfertaCompraEnum,
  verificarPregoeiro,
  verificarComprador,
  verificarVendedor,
  verificarFornecedor,
  verificarLicitante,
  verificarVisitante,
};
